import {
    BymoPageCommonProps,
    BymoPageFeatures,
    BymoPageFeaturesProps,
    BymoPageProps,
    BymoPagePropsContentSettingsMetadata,
    BymoPagePropsWithPartialTemplateProps,
    BymoPageSharedCommonProps
} from '../../client-server-common';
import {Evaluable, IsAny} from '@wix/devzai-utils-common';

export interface BymoTemplateMetadata<
    PARAMS extends {} = any,
    FEATURES extends BymoPageFeatures[] = BymoPageFeatures[]
> {
    initialValues: Evaluable<(params: Partial<BymoPageCommonProps>) => PARAMS & Partial<BymoPageCommonProps>>;
    resolveProps?: (bymoPagePRops : BymoPagePropsWithPartialTemplateProps<PARAMS>) =>  BymoPageProps<PARAMS>;
    features: FEATURES;
    templatePropsMetadata: IsAny<NoInfer<PARAMS>> extends true ? any : BymoPagePropsContentSettingsMetadata<PARAMS>
    // templatePropsMetadata: BymoPagePropsContentSettingsMetadata<PARAMS>
}

export type BymoTemplateMetadataInferBymoPageProps<METADATA extends BymoTemplateMetadata> =
    METADATA extends BymoTemplateMetadata<infer PARAMS, infer FEATURES> ?
        PARAMS & BymoPageSharedCommonProps & Pick<BymoPageCommonProps,
            FEATURES extends (infer FEATURE)[] ? FEATURE extends BymoPageFeatures ? (keyof BymoPageFeaturesProps[FEATURE]) : never : never
        > :
        never;

export interface BymoTemplateData<METADATA extends BymoTemplateMetadata = any> {
    componentType: React.ComponentType<BymoTemplateMetadataInferBymoPageProps<METADATA>>;
    initialValues: METADATA['initialValues'];
    features: METADATA['features'];
    templatePropsMetadata: METADATA['templatePropsMetadata'];
}

export function bymoTemplateMetadataFactoryCreate<PARAMS extends {}> () {
    return <METADATA extends BymoTemplateMetadata<PARAMS>>(bymoTemplateMetadata: METADATA) => bymoTemplateMetadata as BymoTemplateMetadata<PARAMS>
}

export function bymoTemplateDataCreateForMetadata<METADATA extends BymoTemplateMetadata<any>>(
    templateMetadata: METADATA,
    componentType: React.ComponentType<BymoTemplateMetadataInferBymoPageProps<METADATA>>
) : BymoTemplateData<METADATA> {
    return {
        componentType: componentType,
        ...templateMetadata
    };
}